import { makeStyles, tokens } from '@fluentui/react-components';

export const editWorkItemStyles = makeStyles({
	root: {
		width: '100%',
		height: '100%',
		display: 'flex',
		gap: '16px'
	},
	columnFlex: {
		flex: '1 1 0px',
	},
	columnContent: {
		display: 'block',
		width: '100%',
		position: 'relative',
	},
	dropdownRoot: {
		width: '100%',
	},
	dropdown: {
		minWidth: '120px',
		width: '100%',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		'::after': {
			borderBottom: 'none'
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':active': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		}
	},
	dateTimeInputRoot: {
		display: 'flex',
		width: '100%',
		gap: '16px'
	},
	flexItem: {
		flex: '1 1 0px',
	},
	input: {
		width: '100%',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		outline: 'none',
		'::after': {
			borderBottom: 'none',
			height: 0,
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':focus-within': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1}`,
			borderBottomColor: `${tokens.colorNeutralStroke1}!important`,
			borderTopColor: `${tokens.colorNeutralStroke1}!important`,
			borderRightColor: `${tokens.colorNeutralStroke1}!important`,
			borderLeftColor: `${tokens.colorNeutralStroke1}!important`,
		},
	},
	clearIcon: {
		backgroundColor: 'transparent',
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		color: tokens.colorNeutralForeground2,
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase100,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase100,
		height: '100%',
		width: '100%',
		position: 'relative',
		right: '-4px',
		minWidth: '0px',
		padding: '2px 0px',
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
		},
		':active': {
			background: tokens.colorNeutralBackground4Hover,
		}
	},
	noOptions: {
		color: tokens.colorNeutralForeground3,
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase100,
		padding: '8px 16px',
		overflow: 'hidden',
	},
	skeletonRoot: {
		padding: '0px',
	},
	skeletonItem: {
		height: '32px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	}
});